/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactSegmentMembersResult } from '../../models/api-response-contact-segment-members-result';
import { ContactSegmentMembers } from '../../models/contact-segment-members';

export interface AddContactsToSegment$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: ContactSegmentMembers
}

export function addContactsToSegment(http: HttpClient, rootUrl: string, params: AddContactsToSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegmentMembersResult>> {
  const rb = new RequestBuilder(rootUrl, addContactsToSegment.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactSegmentMembersResult>;
    })
  );
}

addContactsToSegment.PATH = '/v1/api/ui/contactSegment/{ref}/contacts';
